export const unique = (item: unknown, index: number, array: unknown[]) => index === array.indexOf(item)
export function groupByKey<K extends string | number | symbol, V>(obj: Record<K, V[]>, [key, value]: [K, V]): Record<K, V[]> {
  return {
    ...obj,
    [key]: [...(obj[key] ?? []), value].filter(unique),
  }
}
